import { apiGet, apiPost } from './api';

const BASE = '/api/Inbox';

/** GET /api/Inbox — the live "To-Do" queue (reviews, returned items, mitigation actions). */
export function getInbox() {
  return apiGet(BASE);
}

/** GET /api/Inbox/notifications — paged notification feed (bell + History). */
export function getNotifications({ module, unreadOnly = false, skip = 0, take = 20 } = {}) {
  const params = new URLSearchParams();
  if (module) params.set('module', module);
  if (unreadOnly) params.set('unreadOnly', 'true');
  params.set('skip', String(skip));
  params.set('take', String(take));
  return apiGet(`${BASE}/notifications?${params.toString()}`);
}

/** GET /api/Inbox/notifications/unread-count — unread badge count. */
export function getUnreadCount() {
  return apiGet(`${BASE}/notifications/unread-count`);
}

/** POST /api/Inbox/notifications/{id}/read — mark one notification read. */
export function markRead(id) {
  return apiPost(`${BASE}/notifications/${id}/read`);
}

/** POST /api/Inbox/notifications/read-all — mark all the caller's notifications read. */
export function markAllRead() {
  return apiPost(`${BASE}/notifications/read-all`);
}
